module.exports = __webpack_public_path__ + "img/reorder-files.ef80c150.svg";